import { companiesResource } from './resource'

export const companiesService = {
  linkById: (signal) => (id) =>
    companiesResource.post(`/link`, { key: id }, { signal: signal() }),
  forgotClientID: (signal) => () =>
    companiesResource.post(`/link`, { signal: signal() })
}
